/**
 * Replaces color placeholder tokens in SVG markup with institution brand colors.
 *
 * Placeholder mapping:
 * - `#B7EA95` (case-insensitive) -> primaryColor (institution primary/accent)
 * - `fill="black"` / `stroke="black"` -> secondaryColor (institution secondary)
 *
 * Only targets fill and stroke attribute values to avoid replacing "black"
 * in non-color contexts (e.g., clip-path IDs, element names).
 */
export function applySvgColors(
  svg: string,
  primaryColor: string,
  secondaryColor: string
): string {
  return svg
    .replace(/#B7EA95/gi, primaryColor)
    .replace(/fill="black"/g, `fill="${secondaryColor}"`)
    .replace(/stroke="black"/g, `stroke="${secondaryColor}"`);
}
